module.exports = ".disabled {\r\n\tpointer-events: none;\r\n}"